import { getRouteApi } from '@tanstack/react-router';
import { NumberInput } from 'cpool-components/input/NumberInput';
import { LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormField';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import type { SchemaLivingSituationForm } from '~/features/leadDetails/schemas/living.schema.ts';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

type Props = {
    antragsteller: 1 | 2;
};

const NumberOfPeopleInHouse: React.FC<Props> = ({ antragsteller }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { control } = useFormContext<SchemaLivingSituationForm>();
    const { t } = useTranslation();

    return (
        <FormField<SchemaLivingSituationForm, number | null>
            control={control}
            name={`antragsteller${antragsteller}.wohnsituation.anzahlPersonenImHaushalt`}
        >
            {({ error, onChange, value }) => (
                <NumberInput
                    id={`antragsteller${antragsteller}.wohnsituation.anzahlPersonenImHaushalt`}
                    label={t('LIVING_SITUATION_DATA.HAUSHALT.PERSONS_IN_HOUSEHOLD')}
                    labelClassName="h-8 w-[175px] shrink-0 justify-start"
                    className="w-full"
                    value={value}
                    onChange={onChange}
                    min={0}
                    allowDecimals={false}
                    disabled={
                        !canExecuteApplicantCommand({
                            applicant: antragsteller,
                            commandName: LOAN_REQUEST_COMMANDS.changeApplicantLivingSituation,
                            permissions,
                        })
                    }
                    error={error}
                />
            )}
        </FormField>
    );
};

export default NumberOfPeopleInHouse;
